export default "__VITE_ASSET__856bd96c__"